import type {InlineNotificationModel} from '@/types/aem';

export const AUTO_DELIVERY_INFO_BOX_SOURCES = {
    DASHBOARD: 'dashboard',
    DETAILS: 'details',
} as const;

export type AutoDeliveryInfoBoxSource =
    (typeof AUTO_DELIVERY_INFO_BOX_SOURCES)[keyof typeof AUTO_DELIVERY_INFO_BOX_SOURCES];

export interface AutoDeliveryInfoBoxData {
    notification: InlineNotificationModel;
}
